import React from 'react';
import {useParams} from 'react-router-dom';
import api from 'controllers/raymanAPI.js';
import { Grid } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import {TextField, PasswordField, Button, Text} from 'components/core';

function NewPassword()
{
    const [password1, updatePassword1] = React.useState("");
    const [password2, updatePassword2] = React.useState("");
    const [errorText, updateErrorText] = React.useState("");
    const [success, setSuccess] = React.useState(false);

    const {token} = useParams();
    async function send()
    {
        if(password1 !== password2)
        {
            updateErrorText("Las contraseñas son diferentes");
        }
        else
        {
            let result = await api.authentication.postPasswordChange({token: token, newPassword: password1});
            if(result.ok)
            {
                setSuccess(true);
            }
            else
            {
                updateErrorText(<><AlertTitle>No se ha podido completar la solicitud</AlertTitle>Por favor, vuelva a intentarlo en unos minutos.</>);
            }
        }
    }

    function keyPress(evt)
    {
        if(evt.charCode === 13)
        {
            send();
        }
    }

    React.useEffect(() => {
        if(password1 !== password2)
        {
            updateErrorText("Las contraseñas son diferentes");
        }
        else
        {
            updateErrorText("");
        }
    }, [password1, password2]);
    return <Grid
            container
            onKeyPress={keyPress}
            direction="column"
            justify="center"
            alignItems="stretch"
            spacing={2}
            >
                <Text title>Nueva contraseña</Text>
        {success ? 
            <><Grid item align="center" className="textBlock"><p>Se ha establecido su nueva contraseña.</p>
            </Grid>
            <Grid item align="center">
            <Button href="/login">Iniciar sesión</Button>
            </Grid></>
        : 
            <>
            { token ? 
                <>{ errorText !== "" ? 
                    <Grid item>
                        <Alert severity="error" isMultiline={true} onDismiss={() => updateErrorText("")} dismissButtonAriaLabel="Close">
                            {errorText}
                        </Alert>
                    </Grid>
                    : ""
                }
                    <Grid item>Introduzca su nueva contraseña</Grid>
                    <Grid item >
                        <PasswordField label="Contraseña" placeholder="" onChange={ (evt) => updatePassword1(evt.target.value)}/>
                    </Grid>
                    <Grid item >
                        <PasswordField label="Repita la contraseña" placeholder="" onChange={ (evt) => updatePassword2(evt.target.value)}/>
                    </Grid>
                    <Grid item />
                    <Grid item align="center">
                        <Button onClick={send} >Guardar contraseña</Button>
                    </Grid>
                </>
            :
                <><Grid item align="center" className="textBlock"><p>No se puede identificar al usuario. Si ha copiado la URL a mano, asegurese de que es correcta.</p>
                </Grid>
                <Grid item align="center">
                <Button href="/">Volver a la página principal</Button>
                </Grid></>
            }
            </>
        }
        </Grid>
}


function ResetPassword()
{
    const [username, updateUsername] = React.useState("");
    const [errorText, updateErrorText] = React.useState("");
    const [success, setSuccess] = React.useState(false);

    async function send()
    {
        let result = await api.authentication.postPasswordReset({email: username});
        if(result.ok)
        {
            setSuccess(true);
        }
        else
        {
            updateErrorText(<><AlertTitle>No se ha podido completar la solicitud</AlertTitle>Por favor, compruebe el e-mail y vuelva a intentarlo.</>);
        }
    }

    function keyPress(evt)
    {
        if(evt.charCode === 13)
        {
            send();
        }
    }
    return <Grid
            container
            onKeyPress={keyPress}
            direction="column"
            justify="center"
            alignItems="stretch"
            spacing={2}
            >
                <Text title>Recuperación de contraseña</Text>
        {success ? 
        <><Grid item align="center" className="textBlock"><p>Se ha enviado un correo a {username} con instrucciones para crear una nueva contraseña.</p>
        <p>Si no lo recibe en unos minutos, compruebe su carpeta de correo no deseado.</p>
        </Grid>
        <Grid item align="center">
        <Button href="/">Volver a la página principal</Button>
        </Grid></>
        : 
        <>{ errorText !== "" ? 
            <Grid item>
                <Alert severity="error" isMultiline={true} onDismiss={() => updateErrorText("")} dismissButtonAriaLabel="Close">
                    {errorText}
                </Alert>
            </Grid>
            : ""
        }
            <Grid item>Introduzca el correo con el que inicia sesión habitualmente</Grid>
            <Grid item >
                <TextField label="Email" placeholder="user@example.com" onChange={ (evt) => updateUsername(evt.target.value)}/>
            </Grid>
            <Grid item />
            <Grid item align="center">
                <Button onClick={send} >Restablecer contraseña</Button>
            </Grid>
        </>}
        </Grid>
}

export {NewPassword, ResetPassword};